import FormInputSelect from 'components/FormElements/FormInputSelect/FormInputSelect.vue'
import tabNavigation from 'foundation/js/utils/tabNavigation'
import { useSearchStore } from 'stores/search.store'
import { computed, onMounted } from 'vue'

export default {
    name: "FilterConcept",
    components: {
        FormInputSelect
    },
    props: {
        guid: {
            type: String,
            required: true
        },
        searchKey: {
            type: String,
            required: true
        },
        filters: {
            type: Array,
            required: false
        }
    },
    setup(props) {
        const searchStore = useSearchStore()

        const filters = computed(() => {
            return getStoreFilters()
        })

        const tags = computed(() => searchStore.tags[props.searchKey])

        onMounted(() => {
            searchStore.setFilters({
                guid: props.guid,
                searchKey: props.searchKey,
                filters: props.filters
            })

            document.addEventListener('click', (e) => {
                const clickedInsideDropdown = (focusElement) => {
                    const dropdowns = document.querySelectorAll('.be-filter-concept__filter')
                    for (let i = 0; i < dropdowns.length; i++) {
                        if (dropdowns[i].contains(focusElement)) {
                            return true
                        }
                    }
                }

                if (!clickedInsideDropdown(document.activeElement)) {
                    searchStore.setFilterOpenState({
                        open: false,
                        searchKey: props.searchKey,
                    })
                }
            })
        })

        const getStoreFilters = () => {
            if (searchStore.filters[props.searchKey]) {
                return searchStore.filters[props.searchKey].map((filter) => {
                    return {
                        name: filter.name,
                        label: filter.label,
                        placeholder: filter.placeholder,
                        value: "",
                        options: filter.options.map((option) => {
                            return {
                                value: option.value,
                                name: option.name
                            }
                        }),
                        open: filter.open
                    }
                })
            }
            return []
        }

        const tagExists = (tagVal) => {
            if (tags.value?.find(tag => tag.value === tagVal)) {
                return true
            } 
            return false
        }

        const setFilter = (option) => {

            if (tagExists(option.value)) {
                removeTag(option.value)
                return
            }

            searchStore.setTags({
                guid: props.guid,
                searchKey: props.searchKey,
                tag: {
                    name: option.name,
                    value: option.value
                }
            })
        }

        const removeTag = (tagVal) => {
            searchStore.removeTag({
                guid: props.guid,
                searchKey: props.searchKey,
                tagValue: tagVal
            })
        }

        const openFilterDropdown = (e, name) => {
            searchStore.setFilterOpenState({
                name: name,
                open: true,
                searchKey: props.searchKey
            })
            setTimeout(() => {
                const dropdownFirstItem = e.target.querySelector('.be-filter-concept__filter__dropdown-item')
                if (dropdownFirstItem) {
                    dropdownFirstItem.focus()
                }
            }, 50)
        }

        const closeFilterDropdown = (e, name) => {
            searchStore.setFilterOpenState({
                name: name,
                open: false,
                searchKey: props.searchKey
            })
        }

        const handleDropdownItemKeyEvent = (e, option, filterName) => {
            const parent = e.target.closest('.be-filter-concept__filter')
            const tabProps = {
                parentContainer: parent,
                targetClassName: 'be-js--filter-concept__filter__dropdown-item',
                key: e.key,
            }

            const tabTraps = new tabNavigation(tabProps)

            switch (e.key) {
                case 'Tab':
                    e.preventDefault()
                    if (e.shiftKey) {
                        tabTraps.tabTrapPrev()
                    } else {
                        tabTraps.tabTrapNext()
                    }
                    break
                case 'ArrowDown':
                case 'ArrowRight':
                    e.preventDefault()
                    tabTraps.tabTrapNext()
                    break
                case 'ArrowUp':
                case 'ArrowLeft':
                    e.preventDefault()
                    tabTraps.tabTrapPrev()
                    break
                case 'Escape':
                    searchStore.setFilterOpenState({ 
                        name: filterName, 
                        open: false, 
                        searchKey: props.searchKey 
                    })
                    setTimeout(() => { parent.focus() }, 50)
                    break
                
                case 'Spacebar':
                case 'Enter':
                    e.preventDefault()
                    setFilter(option)
                    break
                default:
                    break
            }
        }

        return {
            filters,
            tags,
            tagExists,
            setFilter,
            removeTag,
            openFilterDropdown,
            closeFilterDropdown,
            handleDropdownItemKeyEvent
        }
    }
}